export const authSelector = ({ auth }) => auth;
